import styled from 'styled-components';
import { borderColors, spacing } from 'ui/theme';
import { RefObject } from 'react';
import { OptOutDisclaimer } from 'modules/templateEditor/common/OptOutDisclaimer';
import { MergeTagMenuButton } from './MergeTagsMenuButton';
import { WhatsAppFormattingButtons } from './WhatsAppFormattingButtons';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.half};
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: ${spacing.quarter};
  margin: ${spacing.quarter} ${spacing.quarter};
`;

const ButtonDivider = styled.div`
  margin: ${spacing.half} 0;
  width: 0;
  border: 1px solid ${borderColors.borderPrimarySubtle};
`;

type TextAreaFieldToolbarProps = {
  hasSecondaryText?: boolean;
  onSnippetButtonClick: () => void;
  onDynamicContentButtonClick: () => void;
  showMergeTag?: boolean;
  showMarkdownOptions?: boolean;
  inputRef?: RefObject<HTMLTextAreaElement> | null;
  mediumDataKey?: string;
};

export const TextAreaFieldToolbar = ({
  hasSecondaryText,
  showMergeTag = false,
  showMarkdownOptions = false,
  mediumDataKey,
  inputRef,
}: TextAreaFieldToolbarProps) => {
  return (
    <Wrapper>
      {hasSecondaryText && <OptOutDisclaimer />}
      <ButtonGroup>
        {showMergeTag && mediumDataKey && (
          <MergeTagMenuButton mediumRef={inputRef} mediumField={mediumDataKey} />
        )}
        {showMergeTag && showMarkdownOptions && <ButtonDivider />}
        {showMarkdownOptions && mediumDataKey && (
          <WhatsAppFormattingButtons inputRef={inputRef} mediumField={mediumDataKey} />
        )}
      </ButtonGroup>
    </Wrapper>
  );
};
